import { Component } from '@verndale/core';
import Pristine from 'pristinejs';
import serialize from 'form-serialize';
import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import axios from 'axios';
import MicroModal from 'micromodal';
import { SERIALIZE_SETTINGS } from '../utils/default-settings';
import { onlyIntegerNoLeadingZero } from '../utils/numbers';
import MultiClamp from 'multi-clamp';
import { isPhoneOnly, isTabletPortraitOnly } from '../utils/breakpoints';
import striptags from 'striptags';
import { data } from 'jquery';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $search: this.el._$('.coveo-search-section'),
      $btnSubmit: this.el._$(
        '.modal-notify-me__form button[type="submit"]'
      ),
      $formNotifyMe: this.el._$('.modal-notify-me__form')
    };

    this.sdsEndpoint = this.el.dataset.sdsEndpoint;
    this.sdsModalId = this.el.dataset.sdsModalId;
    this.requestSdsModalId = this.el.dataset.requestSdsModalId;
    this.productSheetModalId = this.el.dataset.productSheetModalId;

    this.filtersExpandedClass = 'product-category-listing--filters-expanded';
    this.showMessageClass = 'buy-now-widget__message--show';
    this.showMessageCenterClass = 'buy-now-widget__message--show-center';
  }

  addListeners() {
    const { $formNotifyMe } = this.dom;
    document._on('click', this.openSdsModal.bind(this));
    document._on('click', this.openProductSheetModal.bind(this));
    document._on(constEvent.COVEO_RESULTS_UPDATED, this.bindMethods.bind(this));
    document._on(
      constEvent.COVEO_RESULTS_UPDATED_AJAX,
      this.bindMethodsAjax.bind(this)
    );
    document._on(
      constEvent.REMOVED_COMPARE_PRODUCT,
      this.hideLimitErrorMessages.bind(this)
    );
    $formNotifyMe?._on('submit', this.submitForm.bind(this));

  }

  toggleFiltersDisplay() {
    const isExpanded = this.el.classList.contains(this.filtersExpandedClass);

    if (isExpanded) {
      this.el.classList.remove(this.filtersExpandedClass);
    } else {
      this.el.classList.add(this.filtersExpandedClass);
    }
  }

  openRequestSdsModal() {
    MicroModal.show(this.requestSdsModalId, {
      openTrigger: 'data-generic-modal-open',
      closeTrigger: 'data-generic-modal-close',
      openClass: 'generic-modal--open',
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true
    });
  }

  openProductSheetModal(e) {
    const el = e.target.closest(
      '.product-category-listing__product-sheet-modal-trigger'
    );
    if (!el) return;

    MicroModal.show(this.productSheetModalId, {
      openTrigger: 'data-generic-modal-open',
      closeTrigger: 'data-generic-modal-close',
      openClass: 'generic-modal--open',
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true
    });
  }

  async openSdsModal(e) {
    const el = e.target.closest('.product-category-listing__sds-modal-trigger');
    if (!el) return;

    e?.preventDefault();
    e?.stopPropagation();
    const { data } = await axios.get(`${this.sdsEndpoint}?id=${el.id}`);
    if (data.SDSExists) {
      dispatchGenericEvent(constEvent.SHOW_SDS_MODAL, {
        id: this.sdsModalId,
        ...data
      });
    } else {
      this.openRequestSdsModal();
    }
  }

  bindMethods() {
    window.setTimeout(() => {
      const $slides = [
        ...this.el._$$('.product-search-listing-card'),
        ...this.el._$$('.document-listing-card'),
        ...this.el._$$('.faq-listing-card')
      ];
      if ($slides.length) {
        $slides.forEach($slide => {
          if ($slide.classList.contains('initialized')) return;

          $slide.classList.add('initialized');

          const dom = {
            $form: $slide._$('form'),
            $quantity: $slide._$('.field__input'),
            $btnAddToCart: $slide._$('button[type="submit"]'),
            $btnAddToList: $slide._$('.btn--flat'),
            $notifyMeButton : $slide._$('.buy-now-notify-me-wrapper .btn'),
            $compareCheckbox: $slide._$$('input[name="compare"]'),
            $message: $slide._$('.product-listing__message')
          };

          dom.$compareCheckbox._on('change', e => {
            this.handleCompareChange(e);
          });

          try {
            dom.$btnAddToList?.unbind();
          } catch {
            //catch
          }
          dom.$btnAddToList?._on('click', e => this.addToList(e, dom));

          try {
            dom.$notifyMeButton?.unbind();
          } catch {
            //catch
          }
          dom.$notifyMeButton?._on('click', e => this.showModal(e, dom));

          this.addFiltersTrigger();
          this.addFiltersTitle();
          this.truncateFaqCards();

          this.truncateProductDocumentCards();

          if (!dom.$form) return;
          const pristine = new Pristine(dom.$form, this.pristineSettings);

          try {
            dom.$btnAddToCart?.unbind();
          } catch {
            //catch
          }
          dom.$btnAddToCart?._on('click', e =>
            this.addToCart(e, dom, pristine)
          );

          try {
            dom.$quantity?.unbind();
          } catch {
            //catch
          }
          dom.$quantity?._on('input', e =>
            this.validateQuantity(e, dom, pristine)
          );
        });

        this.addFiltersTrigger();
        this.addFiltersTitle();
        this.truncateFaqCards();

        this.checkInComparelist($slides);
      } else {
        this.bindMethods();
      }
    }, 500);
  }

  bindMethodsAjax(e) {
    const detail = e?.detail || null;
    if (!detail) return;

    const $buyNowWrapper = this.el._$(`#${detail}`);

    if (!$buyNowWrapper) return;

    if ($buyNowWrapper.classList.contains('initialized')) return;
    $buyNowWrapper.classList.add('initialized');

    const dom = {
      $form: $buyNowWrapper._$('form'),
      $quantity: $buyNowWrapper._$('.field__input'),
      $btnAddToCart: $buyNowWrapper._$('button[type="submit"]'),
      $btnAddToList: $buyNowWrapper._$('.btn--flat'),
      $notifyMeButton : $buyNowWrapper._$('.buy-now-notify-me-wrapper .btn'),
      $message: $buyNowWrapper._$('.product-listing__message')
    };

    try {
      dom.$btnAddToList?.unbind();
    } catch {
      //catch
    }
    dom.$btnAddToList?._on('click', e => this.addToList(e, dom, pristine));

    try {
      dom.$notifyMeButton?.unbind();
    } catch {
      //catch
    }
    dom.$notifyMeButton?._on('click', e => this.showModal(e, dom));

    if (!dom.$form) return;
    const pristine = new Pristine(dom.$form, this.pristineSettings);

    try {
      dom.$btnAddToCart?.unbind();
    } catch {
      //catch
    }
    dom.$btnAddToCart?._on('click', e => this.addToCart(e, dom, pristine));

    try {
      dom.$quantity?.unbind();
    } catch {
      //catch
    }
    dom.$quantity?._on('input', e => this.validateQuantity(e, dom, pristine));
  } //bindMethodsAjax

  addFiltersTitle() {
    const titleClass = 'product-category-listing__facets-title';
    const $titleElement = this.el._$(`.${titleClass}`);
    if ($titleElement) return;
    const $title = document.createElement('h3');
    $title.classList.add(titleClass);
    $title.textContent = 'Refine By';
    this.dom.$search.parentNode.insertBefore(
      $title,
      this.dom.$search.nextSibling
    );
  }

  addFiltersTrigger() {
    const triggerClass = 'product-category-listing__facets-display-trigger';
    const $filterTrigger = this.el._$(`.${triggerClass}`);
    if ($filterTrigger) return;
    const $button = document.createElement('button');
    $button.classList.add(triggerClass);
    $button.textContent = 'Filters';
    this.dom.$search.prepend($button);
    $button._on('click', this.toggleFiltersDisplay.bind(this));
  }

  addToCart(e, dom, pristine) {
    e?.preventDefault();

    const { $form, $message, $btnAddToCart } = dom;
    const valid = pristine.validate();
    const endpoint = $form.getAttribute('action');

    if (valid) {
      const formData = serialize($form, SERIALIZE_SETTINGS);
      this.hideMessage(dom);
      $btnAddToCart.disabled = true;

      this.post(endpoint, formData)
        .then(response => {
          const { success, body, message } = response?.data;

          if (success) {
            const { dispatchEvent } = body;
            if (dispatchEvent) {
              dispatchGenericEvent(dispatchEvent, body);
            }
            this.updateProductStatusToAddedToCart($form);
          } else {
            $message.innerHTML = message;
            $message.classList.add(this.showMessageCenterClass);
          }
        })
        .finally(() => {
          $btnAddToCart.disabled = false;
        });
    } else {
      this.showQuantityErrorMessage(dom, pristine);
    }
  }

  post(endpoint, data) {
    return axios({
      method: 'post',
      url: endpoint,
      data,
      headers: {
        'content-type': 'application/json'
      }
    });
  }

  addToList(e, dom) {
    e?.preventDefault();
    const { $btnAddToList } = dom;

    const productId = $btnAddToList?.getAttribute('data-product-id') || null;
    dispatchGenericEvent(constEvent.SHOW_ADD_TO_LIST_MODAL, productId);
  }

  handleCompareChange(e) {
    const $compareCheckbox = e.currentTarget;
    let compareProducts =
      localStorage.getItem(constEvent.COMPARE_LOCAL_STORAGE_NAME) || [];
    if (!compareProducts || compareProducts.length > 0) {
      compareProducts = JSON.parse(compareProducts);
    }

    if ($compareCheckbox.checked) {
      if (compareProducts.length < 5) {
        const product = {
          name: $compareCheckbox.getAttribute('data-product-name'),
          number: $compareCheckbox.getAttribute('data-product-id')
        };
        compareProducts.push(product);
        this.hideLimitErrorMessages();
      } else {
        $compareCheckbox.checked = false;
        this.showLimitErrorMessage(e?.currentTarget);
      }
    } else {
      this.hideLimitErrorMessages();
      compareProducts.forEach((item, index) => {
        if (item.number === $compareCheckbox.getAttribute('data-product-id')) {
          compareProducts.splice(index, 1);
        }
      });
    }

    localStorage.setItem(
      constEvent.COMPARE_LOCAL_STORAGE_NAME,
      JSON.stringify(compareProducts)
    );
    dispatchGenericEvent(constEvent.ADD_TO_COMPARE_LIST, $compareCheckbox);
  }

  checkInComparelist($products) {
    let compareProducts =
      localStorage.getItem(constEvent.COMPARE_LOCAL_STORAGE_NAME) || [];
    if (!compareProducts || compareProducts.length > 0) {
      compareProducts = JSON.parse(compareProducts);
    }
    $products.forEach($product => {
      const $compareCheckbox = $product._$('input[name="compare"]');
      compareProducts.forEach(compareProduct => {
        if ($compareCheckbox?.dataset?.productId === compareProduct.number) {
          $compareCheckbox.checked = true;
        }
      });
    });
  }

  validateQuantity(e, dom, pristine) {
    const value = e.target.value;
    e.target.value = onlyIntegerNoLeadingZero(value);

    this.showQuantityErrorMessage(dom, pristine);
  }

  showQuantityErrorMessage(dom, pristine) {
    const { $message } = dom;
    const errors = pristine.getErrors();

    if (errors.length) {
      const errorMessage =
        errors[0]?.input?.dataset?.pristineRequiredMessage || null;
      if (errorMessage) {
        $message.textContent = errorMessage;
        $message.classList.add(this.showMessageClass);
      }
    } else {
      this.hideMessage(dom);
    }
  }

  hideMessage(dom) {
    const { $message } = dom;

    $message.classList.remove(this.showMessageClass);
    $message.classList.remove(this.showMessageCenterClass);
  }

  updateProductStatusToAddedToCart($form) {
    const label = this.el.dataset?.labelAddedToCart || 'Added to cart';
    $form._$('.product-listing__atc-wrapper').innerHTML = `
      <button type="button" class="btn btn--tertiary btn--full-width">
        <span>${label}</span>
      </button>
    `;
  }

  getLinesToTruncateForFaqQuestion() {
    if (isPhoneOnly()) return 3;
    if (isTabletPortraitOnly()) return 2;
    return 1;
  }

  getLinesToTruncateForFaqDetails() {
    if (isPhoneOnly()) return 4;
    if (isTabletPortraitOnly()) return 6;
    return 2;
  }

  getLinesToTruncateForProductDocumentContent() {
    if (isPhoneOnly()) return 4;
    if (isTabletPortraitOnly()) return 6;
    return 2;
  }

  truncateFaqCards() {
    _$$('.faq-listing-card').forEach(card => {
      const content = card._$('.basic-rte');
      const question = card._$('.document-listing-card__title');

      this.truncateHtmlTitle(question);
      if (isPhoneOnly()) this.truncateHtmlContent(content);

      new MultiClamp(question, {
        ellipsis: '...',
        clamp: this.getLinesToTruncateForFaqQuestion()
      });

      new MultiClamp(content, {
        ellipsis: '...',
        clamp: this.getLinesToTruncateForFaqDetails()
      });
    });
  }

  truncateProductDocumentCards() {
    _$$('.document-listing-card:not(.faq-listing-card)').forEach(card => {
      const content = card._$('.basic-rte');
      if (!content) return;

      if (isPhoneOnly()) this.truncateHtmlContent(content);

      new MultiClamp(content, {
        ellipsis: '...',
        clamp: this.getLinesToTruncateForProductDocumentContent()
      });
    });
  }

  truncateHtmlContent(content) {
    const html = content?.innerHTML || null;
    if (!html) return;

    const outputHtml = striptags(html, [
      'b',
      'strong',
      'i',
      'em',
      'sup',
      'sub',
      's',
      'strike',
      'u',
      'br'
    ]);

    content.innerHTML = outputHtml;
  } //truncateHtmlContent

  truncateHtmlTitle(content) {
    const html = content?.innerHTML || null;
    if (!html) return;

    const outputHtml = striptags(html, [
      'a',
      'i',
      'em',
      'sup',
      'sub',
      's',
      'strike',
      'u'
    ]);

    content.innerHTML = outputHtml;
  } //truncateHtmlTitle

  showLimitErrorMessage(target) {
    const $error = target?.parentNode?._$('.field__msg--error');
    $error?.classList.add('visible');
  } //showLimitErrorMessage

  hideLimitErrorMessages() {
    const $errors = this.el._$$(
      '.product-search-listing-card .product-search-listing-card__actions .field__msg--error'
    );

    for (const $error of $errors) {
      $error?.classList.remove('visible');
    }
  } //hideLimitErrorMessages

  submitForm(e) {
    e.preventDefault();
    const { $form, $btnSubmit, $errorMessage } = this.dom;
    const formData = serialize($form, SERIALIZE_SETTINGS);
    const valid = this.pristineForm.validate();
    const endpoint = $form.getAttribute('action');

    if (valid) {
      $btnSubmit.disabled = true;
      if ($errorMessage){
        $errorMessage.style.display = 'none';
      }

      axios({
        method: 'post',
        url: endpoint,
        data: formData,
        headers: {
          'content-type': 'application/json'
        }
      })
        .then(response => {
          const { success, message } = response?.data;

          if (success) {
            MicroModal.close(this.modalId);
            location.reload();
          } else {
            $errorMessage.innerHTML = message;
            $errorMessage.style.display = 'block';
          }
        })
        .finally(() => {
          $btnSubmit.disabled = false;
        });
    }
  } //submitForm

}

export default Module;
